import axios from "../axiosInstance"

export type PortalExtractionRecord = {
  id: number
  dealId: number
  companyId: number
  companyName: string | null
  clientName: string | null
  fileName: string | null
  dropboxPath: string | null
  dataType: "fmv" | "strike_price"
  value: number | null
  date: string | null
  grantDescription: string | null
  grantType: string | null
  vestedShares: number | null
  totalShares: number | null
  confidence: number
  status: "pending" | "confirmed" | "dismissed" | "applied" | "auto_resolved"
  confirmedAt: string | null
  confirmedBy: { name: string } | null
  appliedAt: string | null
  createdAt: string
  deal?: {
    id: number
    dealIdStr: string
    dealManager: { id: number; name: string }
    client: { firstName: string; lastName: string }
    company: { id: number; name: string }
  }
}

// ── Admin / list queries ────────────────────────────────────────────────────────

export const getPortalExtractions = async (status?: string): Promise<PortalExtractionRecord[]> => {
  const res = await axios.get("/portal-extraction", { params: status ? { status } : {} })
  return res.data.records
}

export const getPortalExtractionFilePreviewTokenUrl = async (id: number): Promise<string> => {
  const res = await axios.get(`/portal-extraction/${id}/file-preview-token`)
  return res.data.url
}

// ── DM-scoped queries ───────────────────────────────────────────────────────────

export const getPendingExtractions = async (managerId?: number): Promise<PortalExtractionRecord[]> => {
  const params = managerId ? { managerId } : {}
  const res = await axios.get("/portal-extraction/pending", { params })
  return res.data.records
}

export const getPendingCount = async (): Promise<{ count: number; totalCount: number | null }> => {
  const res = await axios.get("/portal-extraction/pending-count")
  return res.data
}

// ── Single-item actions ─────────────────────────────────────────────────────────

export const confirmPortalExtraction = async (id: number, overrides?: { value?: number; date?: string }) => {
  const res = await axios.post(`/portal-extraction/${id}/confirm`, overrides || {})
  return res.data
}

export const dismissPortalExtraction = async (id: number) => {
  const res = await axios.post(`/portal-extraction/${id}/dismiss`)
  return res.data
}

// ── Bulk actions ────────────────────────────────────────────────────────────────

export const bulkConfirmExtractions = async (ids: number[]) => {
  const res = await axios.post("/portal-extraction/bulk-confirm", { ids })
  return res.data
}

export const bulkDismissExtractions = async (ids: number[]) => {
  const res = await axios.post("/portal-extraction/bulk-dismiss", { ids })
  return res.data
}

// ── Reconciliation ──────────────────────────────────────────────────────────────

export const reconcileDealExtractions = async (dealId: number) => {
  const res = await axios.post(`/portal-extraction/${dealId}/reconcile`)
  return res.data
}

// ── Admin ───────────────────────────────────────────────────────────────────────

export const purgePortalUploadFmv = async () => {
  const res = await axios.post("/portal-extraction/purge")
  return res.data
}
